/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let FeatureBasedRecommendationsImport;
let QuestionsAndAnswersAccordionBodyImport;
let RatingsAndReviewsAccordionBodyImport;
let SpecificationsAccordionBodyImport;
let ProductOverviewAccordionBodyImport;

/** *********************
 * FBR
 ********************** */
export const FeatureBasedRecommendationsLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "feature-based-recommendations" */
  '@thd-olt-component-react/feature-based-recommendations')
  .then((module) => {
    const { FeatureBasedRecommendations } = module;

    FeatureBasedRecommendationsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="fbr">
          <FeatureBasedRecommendations {...props} />
        </QueryProvider>
      );
    };
  });

export const FeatureBasedRecommendations = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/feature-based-recommendations')).FeatureBasedRecommendations
  : (props) => <FeatureBasedRecommendationsImport {...props} />;

export const FeatureBasedRecommendationsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/feature-based-recommendations')).FeatureBasedRecommendations.dataModel
  : {};

/** *********************
 * Questions and Answers
 ********************** */
export const QuestionsAndAnswersAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "questions-and-answers" */
  '@thd-olt-component-react/questions-and-answers'
).then((module) => {
  const { QuestionsAndAnswersAccordionBody } = module;

  QuestionsAndAnswersAccordionBodyImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <QuestionsAndAnswersAccordionBody {...props} />
      </QueryProvider>
    );
  };
});

export const QuestionsAndAnswersAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionBody
  : (props) => <QuestionsAndAnswersAccordionBodyImport {...props} />;

export const QuestionsAndAnswersAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionBody.dataModel
  : {};

/** *********************
 * Ratings and Reviews
 ********************** */
export const RatingsAndReviewsAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "ratings-and-reviews" */
  '@thd-olt-component-react/ratings-and-reviews'
).then((module) => {
  const { RatingsAndReviewsAccordionBody } = module;

  RatingsAndReviewsAccordionBodyImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <RatingsAndReviewsAccordionBody {...props} />
      </QueryProvider>
    );
  };
});

export const RatingsAndReviewsAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionBody
  : (props) => <RatingsAndReviewsAccordionBodyImport {...props} />;

export const RatingsAndReviewsAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionBody.dataModel
  : {};

/** *********************
 * Specifications
 ********************** */
export const SpecificationsAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "specifications" */
  '@thd-olt-component-react/specifications'
).then((module) => {
  const { SpecificationsAccordionBody } = module;

  SpecificationsAccordionBodyImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <SpecificationsAccordionBody {...props} />
      </QueryProvider>
    );
  };
});

export const SpecificationsAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
    .SpecificationsAccordionBody
  : (props) => <SpecificationsAccordionBodyImport {...props} />;

export const SpecificationsAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
    .SpecificationsAccordionBody.dataModel
  : {};

/** *********************
 * Product Overview
 ********************** */
export const ProductOverviewAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "product-overview" */
  '@thd-olt-component-react/product-overview'
).then((module) => {
  const { ProductOverviewAccordionBody } = module;

  ProductOverviewAccordionBodyImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <ProductOverviewAccordionBody {...props} />
      </QueryProvider>
    );
  };
});

export const ProductOverviewAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
    .ProductOverviewAccordionBody
  : (props) => <ProductOverviewAccordionBodyImport {...props} />;

export const ProductOverviewAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
    .ProductOverviewAccordionBody.dataModel
  : {};